import API from 'services/api';
import { parseError } from 'services/errorHandler';
import { sendGetPageFailMessage } from 'services/iframeService';
import { displaySpinner, hideSpinner } from 'redux/actions/global';
import * as CONSTS from 'redux/constants';
import { CARD_ISSUING_ERROR, APP_ROUTE_NOT_FOUND } from 'routes/paths';
import { redirectToError } from 'utilities/error';
import { HOSTED_PAGE_TYPES } from 'consts';
import { isFunction } from 'lodash-es';

export const getIssuedPageDataStart = () => ({
  type: CONSTS.GET_ISSUED_PAGE_DATA_START
});

export const getIssuedPageDataSuccess = page => ({
  type: CONSTS.GET_ISSUED_PAGE_DATA_SUCCESS,
  payload: page
});

export const getIssuedPageDataFail = (error, data) => ({
  type: CONSTS.GET_ISSUED_PAGE_DATA_FAIL,
  payload: { error, data }
});

export const getIssuedCardStart = () => ({
  type: CONSTS.GET_ISSUED_CARD_START
});

export const getIssuedCardSuccess = (page, muteEvent = false) => ({
  type: CONSTS.GET_ISSUED_CARD_SUCCESS,
  payload: { data: page },
  meta: { muteEvent }
});

export const getIssuedCardFail = error => ({
  type: CONSTS.GET_ISSUED_CARD_FAIL,
  payload: { error }
});

export const setIssuedCardAsExpired = () => ({
  type: CONSTS.SET_ISSUED_CARD_AS_EXPIRED
});

export const getIssuedPageData = token => async dispatch => {
  const handleGetPageError = (error, url = '') => {
    const { status, data } = parseError(error);
    dispatch(getIssuedPageDataFail(status, data));
    redirectToError({ error, url });
  };

  if (!token) {
    sendGetPageFailMessage(HOSTED_PAGE_TYPES.cardIssuing)();
    return redirectToError({ url: APP_ROUTE_NOT_FOUND });
  }

  try {
    dispatch(displaySpinner());
    dispatch(getIssuedPageDataStart());

    let page;
    try {
      page = await API.get(`hosted/issuing/card_details/${token}`);
    } catch (error) {
      return handleGetPageError(error, APP_ROUTE_NOT_FOUND);
    }

    if (page.data?.data) {
      dispatch(getIssuedCardSuccess(page.data.data.card));
      dispatch(getIssuedPageDataSuccess(page.data.data));
    }
  } catch (error) {
    handleGetPageError(error, CARD_ISSUING_ERROR);
  } finally {
    dispatch(hideSpinner({ meta: { pageType: HOSTED_PAGE_TYPES.issuing } }));
  }
};

export const getIssuedCard =
  ({ token, issuedCardExpiryMS, successCallback }) =>
  async dispatch => {
    dispatch(getIssuedCardStart());

    try {
      const card = await API.get(`hosted/issuing/card_details/${token}/verified`);

      if (card.data) {
        dispatch(getIssuedCardSuccess(card.data.data));
        if (isFunction(successCallback)) {
          successCallback();
        }
        setTimeout(() => {
          dispatch(setIssuedCardAsExpired());
        }, issuedCardExpiryMS || 180000);
      }
    } catch (error) {
      const { status } = parseError(error);
      dispatch(getIssuedCardFail(status));
      redirectToError({ error, url: CARD_ISSUING_ERROR });
    }
  };
